export const setFetchedMessage=(message)=>{
    return {
        type:"FETCH_MESSAGE",
        payload: message
    }
}
